import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const PlanReason = ({ content }) => {
  const theme = useTheme();
  const isPad = useMediaQuery("(max-width:900px)");

  return (
    <Box
      sx={{
        color: "#fff",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: theme.palette.primary.main,
        marginBottom: "10%",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "21.5px", md: "5vw", lg: "60px" },
          color: theme.palette.white.main,
          whiteSpace: "wrap",
        }}
        align="center"
        variant="body2"
        padding="5%"
      >
        <div
          dangerouslySetInnerHTML={{
            __html: content?.details?.question,
          }}
        ></div>
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          // padding: {
          //   xs: "4% 6% 1% 6%",
          //   sm: "4% 6% 1% 6%",
          //   md: "4% 2% 1% 2%",
          //   lg: "0% 2% 1% 2%",
          // },
          flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            background: "white",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
            borderRadius: { xs: "5vw", sm: "5vw", md: "3vw", lg: "20px" },
            position: "relative",
            padding: {
              xs: "10%",
              sm: "10%",
              md: "18px",
              lg: "50px 30px",
            },
            margin: {
              xs: "5% 10% 5% 10%",
              sm: "5% 10% 5% 10%",
              md: "12px",
              lg: "12px",
            },
            // width: { xs: "80%", sm: "80%", md: "186px", lg: "345px" },
            height: { md: "240px", lg: "150px" },
          }}
        >
          <Typography
            fontSize={{ xs: "15px", md: "2.5vw", lg: "25px" }}
            color="#2f2f2f"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: content?.details?.ans1,
              }}
            ></div>
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            background: "white",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
            borderRadius: { xs: "5vw", sm: "5vw", md: "3vw", lg: "20px" },
            position: "relative",
            padding: {
              xs: "10%",
              sm: "10%",
              md: "18px",
              lg: "50px 30px",
            },
            margin: {
              xs: "5% 10% 5% 10%",
              sm: "5% 10% 5% 10%",
              md: "12px",
              lg: "12px",
            },
            // width: { xs: "80%", sm: "80%", md: "186px", lg: "345px" },
            height: { md: "240px", lg: "150px" },
          }}
        >
          <Typography
            fontSize={{ xs: "15px", md: "2.5vw", lg: "25px" }}
            color="#2f2f2f"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: content?.details?.ans2,
              }}
            ></div>
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            background: "white",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
            borderRadius: { xs: "5vw", sm: "5vw", md: "3vw", lg: "20px" },
            position: "relative",
            padding: {
              xs: "10%",
              sm: "10%",
              md: "18px",
              lg: "50px 30px",
            },
            margin: {
              xs: "5% 10% 5% 10%",
              sm: "5% 10% 5% 10%",
              md: "12px",
              lg: "12px",
            },
            // width: { xs: "80%", sm: "80%", md: "186px", lg: "345px" },
            height: { md: "240px", lg: "150px" },
          }}
        >
          <Typography
            fontSize={{ xs: "15px", md: "2.5vw", lg: "25px" }}
            color="#2f2f2f"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: content?.details?.ans3,
              }}
            ></div>
          </Typography>
        </Box>
      </Box>

      <Box
        mt="2%"
        sx={{
          whiteSpace: { xs: "wrap", sm: "wrap", md: "wrap", lg: "wrap" },
          backgroundColor: theme.palette.secondary.main,
          borderRadius: { xs: "5vw", sm: "5vw", md: "5vw", lg: "20px" },
          position: "relative",
          boxSizing: "border-box",
          padding: {
            xs: "5% 8% 5% 8%",
            sm: "5% 8% 5% 8%",
            md: "5% 10% 5% 10%",
            lg: "25px 166px",
          },
          display: "flex",
          alignItems: "center",
          width: {
            xs: "98%",
            sm: "98%",
            md: "98%",
            lg: "98%",
          },
          marginBottom: "5%",
          justifyContent: "center",
        }}
      >
        <Typography
          fontSize={{ xs: "17px", md: "3vw", lg: "20px" }}
          variant="body2"
          color={theme.palette.white.main}
          align="center"
        >
          {/* <div
            dangerouslySetInnerHTML={{
              __html: content?.details?.description,
            }}
          ></div> */}
          At BKV Energy, our goal is to help you save as much as possible on
          electricity. <br />
          We put our <b>customers first.</b>
        </Typography>
      </Box>
    </Box>
  );
};

export default PlanReason;
